import { sendEventLog } from "../api/eventLog";

// deviceType 판단 로직
const getDeviceType = () => {
  const ua = navigator.userAgent;
  /* 아이패드
     브라우저 이름이 iPad이거나 Mactiontost인 경우
     기기가 동시에 인식할 수 있는 최대 터치 지점의 개수가 1보다 큰 경우(일반 맥북은 터치가 안되므로 0 또는 1)
     터치 이벤트를 지원하는 경우 */
  const isIPad = /iPad|Macintosh/i.test(ua) && (navigator.maxTouchPoints > 1 || 'ontouchstart' in window);
  
  // 'Mobi'가 들어가면 무조건 mobile
  if (/Mobi/i.test(ua)) return "mobile";

  /* 'Android'가 들어가면서 'Mobi'가 들어가지 않으면 갤럭시패드
     아이패드이거나 갤럭시패드면 tablet, 그게 아니라면 desktop */
  if (isIPad || (/Android/i.test(ua) && !/Mobi/i.test(ua))) return "tablet";
  return "desktop";
};

export const logEvent = (eventName, data={}) => {
  /* 아래 로직은 tablet(아이패드, 갤럭시패드)일 경우 desktop으로 나옴
     const deviceType =
     /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
       ? "mobile"
       : "desktop" */
  const {
    hrId,
    drId,
    wordDictId,
    reportType,
    labelMethod,
    seqNo,
    extractChildId = true
  } = data

  const eventData = {
    eventName,
    hrId,
    drId,
    wordDictId,
    reportType,
    labelMethod,
    seqNo,
    extractChildId,
    deviceType: getDeviceType(),
  }
  try {
    sendEventLog(eventData)
  } catch (error) {
    console.error("event log error", error)
  }

}